import { render, staticRenderFns } from "./ChatBubble.vue?vue&type=template&id=a6b162d8&scoped=true&"
import script from "./ChatBubble.vue?vue&type=script&lang=js&"
export * from "./ChatBubble.vue?vue&type=script&lang=js&"
import style0 from "./ChatBubble.vue?vue&type=style&index=0&id=a6b162d8&scoped=true&lang=css&"
import style1 from "./ChatBubble.vue?vue&type=style&index=1&id=a6b162d8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6b162d8",
  null
  
)

export default component.exports